export const OtherRoutePath = {
  Prefix: "other",
  Home: "*",
  Dashboard: "dashboard",
  NotFoundError: "404",
  InternalServerError: "500",
};
